<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-80 md-xsmall-size-80 mx-auto">
      <simple-wizard>
        <template slot="header">
          <h3 class="title">Create Season</h3>
        </template>

        <wizard-tab :before-change="() => validateStep('step1')">
          <template slot="label">
            Season
          </template>
          <first-step ref="step1" @on-validated="firstStep"></first-step>
        </wizard-tab>
      </simple-wizard>
    </div>
  </div>
</template>
<script>
import FirstStep from "./SeasonCreateSteps/FirstStep.vue";
import Swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "@/components";

export default {
  data() {
    return {
      wizardModel: {}
    };
  },
  components: {
    FirstStep,
    SimpleWizard,
    WizardTab
  },
  methods: {
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    getfirstStepData() {
      var data = {
        name: this.$refs["step1"].name,
        period: this.$refs["step1"].period
      };
      var post_data = {};
      for (const field in data) {
        if (data[field]) {
          if (data[field] instanceof Date) {
            post_data[field] = data[field]
              .toLocaleDateString("ko-KR")
              .replaceAll(". ", "-")
              .replaceAll(".", "");
          } else {
            post_data[field] = data[field];
          }
        }
      }
      return post_data;
    },
    firstStep(validated, model) {
      if (validated) {
        let data = this.getfirstStepData();
        this.$store
          .createSeason(data)
          .then(response => {
            this.wizardComplete();
          })
          .catch(error => {
            var message = error.response.data;
            this.$notify({
              message: JSON.stringify(message),
              icon: "add_alert",
              type: "warning",
              verticalAlign: "top",
              timeout: 5000
            });
          });
      }
      this.wizardModel = { ...this.wizardModel, ...model };
      return validated;
    },
    wizardComplete() {
      Swal.fire({
        title: "Season created.",
        text: "Finish",
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      }).then(result => {
        this.$router.push({ name: "Season List" });
      });
    }
  }
};
</script>
